// extracted by mini-css-extract-plugin
export default {"userBox":"UserInfo_userBox__F2sup","userInfoBox":"UserInfo_userInfoBox__939AN","infoBox":"UserInfo_infoBox__4ajTI"};